var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 43,
    viewBox: "0 0 22 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5936 41.8434C21.8804 41.6177 22.0152 41.2505 21.9477 40.8781C21.8979 40.6022 20.8449 39.5215 12.116 30.7869L2.33994 21.0046L12.1137 11.2224C20 3.32915 21.898 1.38875 21.9426 1.1736C22.1403 0.220203 21.1777 -0.352364 20.377 0.242252C19.5796 0.834557 0.0981865 20.4707 0.0427475 20.738C-0.0907077 21.3817 -0.533596 20.9064 10.324 31.7712L20.5507 42.0046L20.9696 42.0046C21.2619 42.0046 21.4505 41.9559 21.5936 41.8434Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.58e71ede488868ffe1e5959868af5963.svg";
export { ForwardRef as ReactComponent };